import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { get_all_orders } from "../../reduxData/user/userAction";
import MyOrders from "./Orders";
import DisputeOrder from "./DisputeOrder";
import ReturnOrder from "./ReturnOrder";
import EmptyData from "../../components/EmptyData";
import "../../css/order.css";
import DataExport from "./DataExport";
import { useLocation, useNavigate } from "react-router-dom";

const Orders = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    // const [activeTab, setActiveTab] = useState("orders");
    const activeTab = location.pathname.split("/")[1];
    const { totalOrders, orderLists } = useSelector((state) => state.user);
    const { userPermissions } = useSelector((state) => state.auth);

    useEffect(() => {
        const fetchOrders = async () => {
            await get_all_orders(dispatch, 1, 10);
        };
        fetchOrders();
    }, [dispatch]);

    return (
        <div className="si-page container">
            <div className="si-page-header">
                <h2 className="mb-0 fw-600">{t("order.Orders")}</h2>
                {((userPermissions?.orders) && (totalOrders > 0)) && <DataExport data={orderLists} />}
            </div>

            {totalOrders > 0 ?
                <>
                    <div className="si-tabs-wrapper">
                        <div className="si-tabs">
                            {userPermissions?.orders?.view && (
                                <button
                                    className={`si-tab ${activeTab === "orders" ? "si-tab--active" : ""}`} onClick={() => navigate("/orders")}>
                                    {t("order.Orders")}
                                </button>
                            )}
                            {userPermissions?.disputes?.view && (
                                <button
                                    className={`si-tab ${activeTab === "disputes" ? "si-tab--active" : ""}`}
                                    onClick={() => navigate("/disputes")}>
                                    {t("order.DisputedOrders")}
                                </button>
                            )}
                            {userPermissions?.returns?.view && (
                                <button
                                    className={`si-tab ${activeTab === "returns" ? "si-tab--active" : ""}`} onClick={() => navigate("/returns")}>
                                     {t("order.ReturnOrders")}
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="si-tab-content">
                        {activeTab === "orders" && <MyOrders />}
                        {activeTab === "disputes" && <DisputeOrder />}
                        {activeTab === "returns" && <ReturnOrder />}
                    </div>
                </> :
                <EmptyData />
            }
        </div>
    );
};

export default Orders;






